// Two sections load this file (twt-promo-banner, twt-home-hero) and both can be
// on the same page. Only `customElements.define` was guarded, so the second
// load still threw a SyntaxError re-declaring the class at top level. Guarding
// the whole file is the convention used by twt-quiz.js.
if (!customElements.get('twt-countdown')) {
  class TwtCountdown extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (!Number.isFinite(end)) return;

      this.units = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };
      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    update() {
      const remaining = Math.max(0, Date.parse(this.dataset.end) - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };

      Object.entries(values).forEach(([key, value]) => {
        if (this.units[key]) this.units[key].textContent = String(value).padStart(2, '0');
      });

      if (remaining === 0) window.clearInterval(this.timer);
    }
  }

  customElements.define('twt-countdown', TwtCountdown);
}
